import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Stack } from '@evaneos/b2b-ui';

import { StepName, Processes } from '../../../../design-system/types';
import { DisplayDossierOverviews } from '../../../../resources/dossier/types';
import s from '../../Process.css';

import { StepTitleBudgetSum } from './StepTitleBudgetSum';

type Props = {
    process: Processes;
    name: StepName;
    value: DisplayDossierOverviews;
    total?: number;
    showTotalBudgetLabel: boolean;
    className?: string;
};

export const StepTitle = ({
    process,
    name,
    total,
    value,
    showTotalBudgetLabel,
    className,
}: Props): JSX.Element => {
    return (
        <Stack mb={1}>
            <h2 data-testid="step-name" className={cx(s.stepTitle, className)}>
                <FormattedMessage id={`steps.${name}.name`} />
                {typeof total === 'number' && total > 0 && process !== 'archive' && (
                    <span data-testid={`dossier-count-${name}`}>{`(${total})`}</span>
                )}
            </h2>
            {process === 'sales' && showTotalBudgetLabel && <StepTitleBudgetSum value={value} />}
        </Stack>
    );
};
